import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '@services/auth.service';
import {ToastService} from '@services/toast.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
	selector: 'app-callback-token',
	imports: [],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './callback-token.component.html',
})
export class CallbackTokenComponent implements OnInit {
	constructor(
		private readonly router: Router,
		private readonly authService: AuthService,
		private readonly toastService: ToastService,
		private readonly translate: TranslateService,
	) {}

	ngOnInit(): void {
		const hash = new URLSearchParams(window.location.hash.substring(1));
		const accessToken = hash.get('access_token');

		if (accessToken) {
			this.authService.storeToken(accessToken);
			this.authService.loadUser().subscribe();
			this.toastService.show(this.translate.instant('page.callback-code.login.success'), 'success', 10000);
			this.router.navigate(['/']);
		} else {
			this.router.navigate(['']);
		}
	}
}
